<template>
  <div class="view-next-releases">
    <page-header
      title="Próximos lançamentos"
      subtitle="Visualize e configure os lançamentos dos seus produtos."
    />
    <page-container>
      <div class="row mb-5 mb-lg-6 flex-column flex-lg-row">
        <div class="col order-1 order-lg-0 d-flex align-items-center gap-3">
          <span class="functional-1">Total: {{ pagination.count || 0 }}</span>
          <bp-button
            size="md"
            color="neutral"
            variant="glyph"
            icon="fa-light fa-refresh"
            @click="dispatch"
          />
        </div>

        <div class="col d-flex flex-column flex-lg-row gap-3">
          <bp-input
            v-model="search"
            size="md"
            placeholder="Pesquisar"
            :delay="600"
            @change="dispatch"
          />

          <bp-button
            size="md"
            icon="fa fa-plus"
            label="Cadastrar novo lançamento"
            @click="$router.push({ name: 'register-releases' })"
          />
        </div>
      </div>

      <div class="my-9 text-center" v-if="loading">
        <b-spinner variant="primary" />
      </div>

      <bp-data-table v-else :columns="columns" :data="releases" />
    </page-container>
  </div>
</template>

<script>
import { clearObject } from "@/functions/helpers";
import { mapState } from "vuex";

import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      search: ""
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    ...mapState("membersReleases", ["releases", "pagination"]),
    columns() {
      return [
        {
          name: "Nome",
          field: "title"
        },
        {
          name: "Produto",
          field: "name"
        },
        {
          name: "Link do produto",
          field: "url",
          type: "link",
          size: "0.7fr"
        },
        {
          name: "Data do lançamento",
          field: "release_at",
          transform: this.formatDate,
          size: "0.7fr"
        },
        {
          name: "Hora do lançamento",
          field: "release_at",
          transform: this.formatTime,
          size: "0.7fr"
        },
        {
          name: "Data de encerramento",
          field: "expires_in",
          transform: this.formatDate,
          size: "0.7fr"
        },
        {
          name: "Status",
          field: "is_active",
          transform: this.formatStatus,
          class: this.formatStatusClass,
          size: "0.5fr"
        },
        {
          name: "",
          type: "menu",
          options: this.getActions
        }
      ];
    }
  },
  mounted() {
    this.dispatch();
  },
  methods: {
    dispatch() {
      let params = { search: this.search };

      this.loading = true;
      this.$store
        .dispatch("membersReleases/get", clearObject(params))
        .catch(error => {
          this.$message.error("Não foi possível carregar os lançamentos");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatStatus(_, item) {
      if (item.is_expired) return "Expirado";
      return item.is_active ? "Ativo" : "Inativo";
    },
    formatStatusClass(_, item) {
      if (item.is_expired) return "expired-badge";
      return item.is_active ? "active-badge" : "inactive-badge";
    },
    formatDate(value) {
      return moment.utc(value).format("DD/MM/YYYY");
    },
    formatTime(value) {
      return moment.utc(value).format("HH:mm");
    },
    getActions(item) {
      return [
        {
          icon: "fa-light fa-power-off",
          label: item.is_active ? "Desativar" : "Ativar",
          color: item.is_active ? "negative" : "positive",
          click: this.changeStatus
        },
        {
          label: "Editar",
          icon: "fa-light fa-pen",
          click: this.editItem
        },
        {
          label: "Excluir lançamento",
          color: "negative",
          icon: "fa-light fa-trash",
          dialog: {
            text: "Deseja mesmo excluir este lançamento?",
            variant: "negative",
            buttonText: "Cancelar",
            icon: "fa fa-hexagon-exclamation",
            secondaryButtonText: "Confirmar",
            secondaryAction: this.deleteItem
          }
        }
      ];
    },
    changeStatus(item) {
      let { id, is_active } = item;
      let data = { id, is_active: !is_active };

      this.$store
        .dispatch("membersReleases/put", data)
        .then(() => {
          this.dispatch();
          this.$message.success(
            `Lançamento ${data.is_active ? "ativado" : "desativado"}!`
          );
        })
        .catch(() => {
          this.$message.error(
            "Não foi possível alterar o status do lançamento"
          );
        });
    },
    deleteItem(item) {
      this.$store
        .dispatch("membersReleases/delete", item.id)
        .then(() => {
          this.dispatch();
          this.$message.success("Lançamento removido");
        })
        .catch(() => {
          this.$message.error("Não foi possível deletar o lançamento");
        });
    },
    editItem(item) {
      this.$router.push({ name: "register-releases", params: { id: item.id } });
    }
  }
};
</script>
